export default __webpack_public_path__ + "static/media/fixRoot.72d6957c.svg";